import { Box, BoxProps } from '@chakra-ui/core'
import React from 'react'
import { BarChart, Bar, Rectangle, XAxis, YAxis, Tooltip, ResponsiveContainer } from 'recharts'
import { theme } from '../../../../theme'
import { randomColor } from '../../../../utils'
import { ChartProps } from './type'
import { STANDARD_GRAPH_HEIGHT } from './constants'

type BarChartProps = ChartProps & BoxProps

const BarChartComponent: React.FC<BarChartProps> = ({
  data,
  xKey,
  yKey,
  barColor = theme.colors.green[400],
  randomizeColors,
  ...rest
}) => {
  const processedData = React.useMemo(() => {
    const results = data.map((entry) => ({
      ...entry,
      fill: randomizeColors ? randomColor() : barColor
    }))
    return results
  }, [data, randomizeColors, barColor])
  const dataLength = processedData.length
  return (
    <Box w="100%" h="100%" fontSize="xs" {...rest}>
      <ResponsiveContainer width="100%" height={STANDARD_GRAPH_HEIGHT}>
        <BarChart data={processedData}>
          <XAxis
            dataKey={xKey}
            {...(dataLength > 10 && {
              interval: 0,
              angle: -45,
              textAnchor: 'end',
              fontSize: '0.8rem',
              fontWeight: 'bold',

              tickFormatter: (value) => {
                return value.length > 6 ? `${value.slice(0, 20)}...` : value
              }
            })}
            tickLine={false}
            axisLine={false}
            height={dataLength > 10 ? 120 : 60} // adjust height based on data length
            tick={{ dy: 30, fontSize: '0.8rem' }}
          />
          <YAxis tickLine={false} axisLine={false} />
          <Tooltip
            contentStyle={{
              backgroundColor: 'white',
              border: '1px solid white',
              borderRadius: '4px',
              boxShadow: 'none',
              fontSize: '0.8rem',
              padding: '8px'
            }}
            labelStyle={{ fontWeight: 'bold' }}
            itemStyle={{ color: theme.colors.gray[700] }}
            cursor={{ fill: 'white' }}
          />

          <Bar
            dataKey={yKey}
            fill={barColor}
            background={{
              fill: '#eee',
              radius: 100
            }}
            label={{ position: 'bottom', fontWeight: 'bold' }}
            shape={<Rectangle radius={[100, 100, 100, 100]} />}
            barSize={15}
          />
        </BarChart>
      </ResponsiveContainer>
    </Box>
  )
}

export default BarChartComponent
